// before 20-5-2026

// import React, { useEffect, useState } from 'react';
// import Container from 'react-bootstrap/esm/Container';
// import Row from 'react-bootstrap/esm/Row';
// import { useDispatch, useSelector } from 'react-redux';
// // import AddIcon from '@mui/icons-material/Add';
// import { Link, useParams } from 'react-router-dom';
// import { GetOnechannalData, UpdateOneChannalData } from '../../Redux/Actions/ChannalActions';
// import { Notify } from '../../Utility/Notify';
// import SyncAltIcon from '@mui/icons-material/SyncAlt';
// import { Col } from 'react-bootstrap';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { CircularProgress, useTheme } from '@mui/material';

// export const UpdateChanel = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li

//   const [userlogin, setuserlogin] = useState('');
//   const [updateChannalLoading, setUpdateChannalLoading] = useState(false);

//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const { id } = useParams();

//   const dispatch = useDispatch();

//   const [name, setname] = useState('');
//   const [code, setcode] = useState('');
//   const [loading, setloading] = useState(true);

//   useEffect(() => {
//     const run = async () => {
//       await dispatch(GetOnechannalData(id));
//     };
//     run();
//   }, [dispatch]);

//   const res_Get_one_channal = useSelector((state) => state.AllChannalRoot.channal);

//   //   let one_channal = Array.isArray(res_Get_one_channal?.data) ? res_Get_one_channal.data : [];

//   let one_channal = [];
//   if (res_Get_one_channal && res_Get_one_channal.data) {
//     one_channal = res_Get_one_channal.data;
//   }

//   useEffect(() => {
//     if (one_channal) {
//       setname(one_channal.name);
//       setcode(one_channal.code);
//     }
//   }, [one_channal]);

//   const namechange = (e) => {
//     setname(e.target.value);
//   };

//   const codechange = (e) => {
//     setcode(e.target.value);
//   };

//   const onsubmitupdate = async (e) => {
//     e.preventDefault();

//     setloading(true);
//     setUpdateChannalLoading(true);

//     await dispatch(
//       UpdateOneChannalData(id, {
//         name,
//         code,
//       }),
//     );
//     setloading(false);
//     setUpdateChannalLoading(false);
//   };

//   const res_update_channal = useSelector((state) => state.AllChannalRoot.UpdateChannal);

//   useEffect(() => {
//     if (loading === false) {
//       if (res_update_channal && res_update_channal.status === 200) {
//         Notify('success', 'Updated Successfully', 'success');
//         setname('');
//         setcode('');
//       } else {
//         Notify('error', 'Failed to Update', 'error');
//         return;
//       }
//     }
//   }, [loading]);
//   // ===================================================
//   const homeRoute =
//     userlogin?.data?.role === 'Admin'
//       ? '/Channel'
//       : userlogin?.data?.role === 'Marketer'
//         ? '/Channel'
//         : '/'; // fallback

//   return (
//     <Container className="startpage">
//       <Row>
//         <Col sm={2}></Col>

//         <Col sm={10}>
//           {/* <div className='mx-4 d-flex'>
//             <div className='mx-3'>Update Channel</div>
//             <a style={{textDecoration:'none'}} href='/channel' className='goback'>{"<<"} Go To Channal </a>
//         </div> */}

//           <div className="d-flex">
//             <div>
//               <div>
//                 <Link to={homeRoute} style={{ textDecoration: 'none', color: '#102dff' }}>
//                   <span style={{ fontWeight: 'bold', color: '#666' }}>Home Channel</span>
//                 </Link>

//                 <KeyboardDoubleArrowRightIcon />

//                 <span>Update Channel</span>
//               </div>
//             </div>
//           </div>

//           {/* inputes of add channal */}
//           <div
//             style={{
//               padding: '25px',
//               borderRadius: '15px',
//               background: mode === 'dark' ? '#333' : '#fff',
//             }}
//           >
//             <div>
//               <div style={{ marginTop: '20px' }}>
//                 <label for="Name">Channal Name*</label>
//                 <input
//                   style={{ background: 'transparent', color: mode === 'dark' ? '#fff' : '#333' }}
//                   onChange={namechange}
//                   value={name}
//                   className="inputsaddclient"
//                   type="text"
//                   id="name"
//                   name="Name"
//                   placeholder="Channal Name.."
//                 />
//               </div>

//               <div style={{ marginTop: '10px' }}>
//                 <label for="Code">Code*</label>
//                 <input
//                   style={{ background: 'transparent', color: mode === 'dark' ? '#fff' : '#333' }}
//                   onChange={codechange}
//                   value={code}
//                   className="inputsaddclient"
//                   type="text"
//                   id="name"
//                   name="Code"
//                   placeholder="Code..."
//                 />
//               </div>

//               {/* <Row className='d-flex justify-content-center' style={{width:'100%',marginTop:'40px',textAlign:'center'}}> */}
//               {/* <div onClick={onsubmitupdate}  className='addnewclient' style={{textAlign:'center',background:'#0F7687'}}  type="submit" ><SyncAltIcon/> Update Channal</div> */}

//               {/* </Row> */}
//             </div>

//             <div className="d-flex justify-content-center w-100">
//               <div
//                 onClick={!updateChannalLoading ? onsubmitupdate : null}
//                 className="addnewclient"
//                 style={{
//                   textAlign: 'center',
//                   background: '#102dff',
//                   pointerEvents: updateChannalLoading ? 'none' : 'auto',
//                   opacity: updateChannalLoading ? 0.6 : 1,
//                   cursor: updateChannalLoading ? 'not-allowed' : 'pointer',
//                 }}
//                 type="submit"
//               >
//                 {updateChannalLoading ? (
//                   <CircularProgress size={20} style={{ color: 'white' }} />
//                 ) : (
//                   <>
//                     <SyncAltIcon /> Update Channal
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };


























// 20-5-2026
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { GetOnechannalData, UpdateOneChannalData } from '../../Redux/Actions/ChannalActions';
import { Notify } from '../../Utility/Notify';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

export const UpdateChanel = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const navigate = useNavigate();
  const sidebarWidth = useSidebarWidth();
  const { id } = useParams();

  const [userlogin, setuserlogin] = useState('');
  const [updateChannalLoading, setUpdateChannalLoading] = useState(false);
  const [name, setname] = useState('');
  const [code, setcode] = useState('');
  const [loading, setloading] = useState(true);
  const [formErrors, setFormErrors] = useState({});
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  const dispatch = useDispatch();

  /* ── Fetch channel data ── */
  useEffect(() => {
    const run = async () => {
      setInitialLoading(true);
      await dispatch(GetOnechannalData(id));
      setInitialLoading(false);
    };
    run();
  }, [dispatch, id]);

  const res_Get_one_channal = useSelector((state) => state.AllChannalRoot.channal);

  let one_channal = [];
  if (res_Get_one_channal && res_Get_one_channal.data) {
    one_channal = res_Get_one_channal.data;
  }

  useEffect(() => {
    if (one_channal && one_channal.name) {
      setname(one_channal.name);
      setcode(one_channal.code);
    }
  }, [one_channal]);

  /* ── validation ── */
  const validate = () => {
    const errors = {};
    if (!name.trim()) errors.name = 'Channel name is required';
    if (!code.trim()) errors.code = 'Code is required';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const onsubmitupdate = async (e) => {
    e.preventDefault();
    if (!validate()) return Notify('error', 'Please fix form errors', 'error');

    setUpdateChannalLoading(true);
    setloading(true);

    await dispatch(
      UpdateOneChannalData(id, {
        name,
        code,
      })
    );
    setloading(false);
    setUpdateChannalLoading(false);
  };

  const res_update_channal = useSelector((state) => state.AllChannalRoot.UpdateChannal);

  useEffect(() => {
    if (loading === false) {
      if (res_update_channal && res_update_channal.status === 200) {
        Notify('success', 'Channel Updated Successfully', 'success');
        setTimeout(() => {
          navigate('/Channel');
        }, 1500);
      } else if (res_update_channal && res_update_channal.status !== 200) {
        Notify('error', res_update_channal.message || 'Failed to update channel', 'error');
      }
      setloading(true);
    }
  }, [loading, res_update_channal, navigate]);

  const homeRoute = userlogin?.data?.role === 'Admin' || userlogin?.data?.role === 'Marketer'
    ? '/Channel'
    : '/';

  /* ─── shared styles ─── */
  const inputStyle = (hasError) => ({
    width: '100%',
    padding: '13px 16px',
    borderRadius: '10px',
    border: `1.5px solid ${hasError ? '#ef4444' : (isDark ? '#2d3248' : '#e2e8f0')}`,
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s',
    fontFamily: "'DM Sans',sans-serif",
    boxSizing: 'border-box',
  });

  const labelStyle = {
    display: 'block',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b',
    marginBottom: '8px',
  };

  const errorStyle = {
    fontSize: '12px',
    color: '#ef4444',
    margin: '5px 0 0',
  };

  const onFocus = (e) => {
    e.target.style.borderColor = '#2563eb';
    e.target.style.backgroundColor = isDark ? '#1a1f35' : '#ffffff';
    e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.12)';
  };

  const onBlur = (e, hasError) => {
    e.target.style.borderColor = hasError ? '#ef4444' : (isDark ? '#2d3248' : '#e2e8f0');
    e.target.style.backgroundColor = isDark ? '#151827' : '#f8fafc';
    e.target.style.boxShadow = 'none';
  };

  const fieldWrap = { marginBottom: '20px' };

  // Loading state while fetching data
  if (initialLoading) {
    return (
      <div style={{
        position: 'fixed',
        top: '50px',
        left: sidebarWidth,
        right: 0,
        bottom: 0,
        transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      }}>
        <CircularProgress size={48} style={{ color: isDark ? '#60a5fa' : '#2563eb' }} />
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      top: '50px',
      left: sidebarWidth,
      right: 0,
      bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
      marginTop: '10px',
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding: '14px 28px',
        backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '13px',
      }}>
        <Link to={homeRoute} style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Home Channel
        </Link>
        <KeyboardDoubleArrowRightIcon sx={{ fontSize: 16, color: isDark ? '#4b5563' : '#d1d5db' }} />
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Update Channel</span>
      </div>

      {/* ── Form ── */}
      <div style={{ padding: '28px 32px 48px' }}>
        <div style={{
          width: '100%',
          maxWidth: '720px',
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '20px',
          padding: '36px 40px',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
        }}>

          {/* title */}
          <div style={{ marginBottom: '28px' }}>
            <h1 style={{
              fontSize: '22px',
              fontWeight: 700,
              color: isDark ? '#f1f5f9' : '#0d1b3e',
              margin: '0 0 4px',
              letterSpacing: '-0.4px'
            }}>
              Update Channel
            </h1>
            <p style={{
              fontSize: '13px',
              color: isDark ? '#6b7280' : '#94a3b8',
              margin: 0
            }}>
              Edit existing marketing channel information
            </p>
          </div>

          {/* ── Channel Name ── */}
          <div style={fieldWrap}>
            <label style={labelStyle}>Channel Name *</label>
            <input
              style={inputStyle(!!formErrors.name)}
              value={name}
              onChange={(e) => {
                setname(e.target.value);
                if (formErrors.name) setFormErrors(p => ({ ...p, name: '' }));
              }}
              type="text"
              placeholder="e.g. Facebook Ads, Google Campaign, Email Marketing"
              onFocus={onFocus}
              onBlur={(e) => onBlur(e, !!formErrors.name)}
              autoFocus
            />
            {formErrors.name && <p style={errorStyle}>{formErrors.name}</p>}
          </div>

          {/* ── Code ── */}
          <div style={fieldWrap}>
            <label style={labelStyle}>Code *</label>
            <input
              style={inputStyle(!!formErrors.code)}
              value={code}
              onChange={(e) => {
                setcode(e.target.value);
                if (formErrors.code) setFormErrors(p => ({ ...p, code: '' }));
              }}
              type="text"
              placeholder="e.g. FB_2026, GOOGLE_01, EMAIL_MARKET"
              onFocus={onFocus}
              onBlur={(e) => onBlur(e, !!formErrors.code)}
            />
            {formErrors.code && <p style={errorStyle}>{formErrors.code}</p>}
            {!formErrors.code && (
              <p style={{
                fontSize: '12px',
                color: isDark ? '#4b5563' : '#94a3b8',
                margin: '5px 0 0'
              }}>
                Unique identifier code for this channel
              </p>
            )}
          </div>

          {/* divider */}
          <div style={{
            height: '1px',
            backgroundColor: isDark ? '#2a2f45' : '#e8eaf0',
            margin: '28px 0'
          }} />

          {/* buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={!updateChannalLoading ? onsubmitupdate : null}
              disabled={updateChannalLoading}
              type="button"
              style={{
                flex: 1,
                padding: '14px 24px',
                borderRadius: '10px',
                border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff',
                fontSize: '13px',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                cursor: updateChannalLoading ? 'not-allowed' : 'pointer',
                opacity: updateChannalLoading ? 0.7 : 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'all 0.2s',
                boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                if (!updateChannalLoading) {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)';
              }}
            >
              {updateChannalLoading ? (
                <>
                  <CircularProgress size={16} style={{ color: '#fff' }} />
                  <span>Updating...</span>
                </>
              ) : (
                <>
                  <SyncAltIcon sx={{ fontSize: 17 }} />
                  <span>Update Channel</span>
                </>
              )}
            </button>

            <button
              type="button"
              onClick={() => navigate('/Channel')}
              style={{
                padding: '14px 28px',
                borderRadius: '10px',
                border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                backgroundColor: 'transparent',
                color: isDark ? '#9ca3af' : '#64748b',
                fontSize: '13px',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                cursor: 'pointer',
                transition: 'all 0.2s',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#4b5563' : '#94a3b8';
                e.currentTarget.style.color = isDark ? '#e5e7eb' : '#374151';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0';
                e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b';
              }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};